
/**
 * 마지막 메시지 역할
 * @nullable
 */
export type ConversationSummaryLastMessageRole = typeof ConversationSummaryLastMessageRole[keyof typeof ConversationSummaryLastMessageRole] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConversationSummaryLastMessageRole = {
  USER: 'USER',
  ASSISTANT: 'ASSISTANT',
  SYSTEM: 'SYSTEM',
} as const;
